import { useEffect, useState } from 'react'
import { workspacesApi, type EmailBrandLookRead } from '../../services/api'

/**
 * The STORED Shopify look (MAR-391) — `GET …/email-brand-detection`, which runs no detection and
 * writes nothing — so the Brand overview can say "Not read / To confirm / Up to date" before
 * How we look has opened. Read once per workspace, owner/admin only (the route refuses anyone
 * else, as the refresh does).
 *
 * Stamped with the workspace it was read for and scoped at the READ, never cleared in an effect:
 * a workspace switch shows nothing for the new one until its own read lands, not the old answer.
 * A failed read is no state — the caller says nothing rather than a guess.
 */
export default function useStoredLook(workspaceId: string | undefined, enabled: boolean): EmailBrandLookRead['state'] | undefined {
  const [read, setRead] = useState<{ workspaceId: string; state: EmailBrandLookRead['state'] | undefined } | null>(null)
  useEffect(() => {
    if (!workspaceId || !enabled) return
    let active = true
    workspacesApi.getEmailBrandDetection(workspaceId)
      .then((res) => { if (active) setRead({ workspaceId, state: res.success && res.data ? res.data.state : undefined }) })
      .catch(() => { if (active) setRead({ workspaceId, state: undefined }) })
    return () => { active = false }
  }, [workspaceId, enabled])
  return enabled && read && read.workspaceId === workspaceId ? read.state : undefined
}
